// extracted by mini-css-extract-plugin
module.exports = {"no-events-message":"ApprovalsView_no-events-message__3664r","no-data-cell":"ApprovalsView_no-data-cell__1WO3_"};